import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "acRemind" }
const _hoisted_2 = { class: "acRemind_wrapper" }
const _hoisted_3 = { class: "acRemind_title" }
const _hoisted_4 = { class: "acRemind_content" }
const _hoisted_5 = { class: "acRemind_item -time" }
const _hoisted_6 = { class: "acRemind_label" }
const _hoisted_7 = { class: "acRemind_timePicker" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "acRemind_icon -time" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4353_14193)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1422 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1422 16.5 9 16.5ZM9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15ZM9.75 9H12.75V10.5H8.25V5.25H9.75V9Z",
        fill: "#3C92FE"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4353_14193" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_9 = { class: "acRemind_item -date" }
const _hoisted_10 = { class: "acRemind_label" }
const _hoisted_11 = { class: "acRemind_actions actions" }
const _hoisted_12 = { class: "actions_wrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z",
    fill: "#F83C43"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mq_responsive = _resolveComponent("mq-responsive")!
  const _component_as_date_time_picker = _resolveComponent("as-date-time-picker")!
  const _component_week_days = _resolveComponent("week-days")!
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_settings_content = _resolveComponent("settings-content")!

  return (_openBlock(), _createBlock(_component_settings_content, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_mq_responsive, { target: "desktop" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('addNotification')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('videoConsultations.time')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_as_date_time_picker, {
                  name: "time",
                  type: "time",
                  "onUpdate:modelValue": _ctx.updateRemindTrainingTime,
                  "model-value": _ctx.remindTrainingTime,
                  "minute-interval": 10,
                  class: "acRemind_asInput -only-text"
                }, null, 8, ["onUpdate:modelValue", "model-value"]),
                _hoisted_8
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_week_days, {
                days: _ctx.weekDayList,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleWeekDayStatus($event))),
                class: "acRemind_weekDays"
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('weekDay')), 1)
                ]),
                _: 1
              }, 8, ["days"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ac_button, {
                disabled: _ctx.isDisabledSaveBtn,
                class: "actions_button -save",
                "data-text": _ctx.$t('Save'),
                onClick: _ctx.saveChanges
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "data-text", "onClick"]),
              (_ctx.isShowRemoveBtn)
                ? (_openBlock(), _createBlock(_component_ac_button, {
                    key: 0,
                    class: "actions_button -remove",
                    "data-text": _ctx.$t('Remove'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.remove(_ctx.remindTrainingTime))),
                    variant: "outlined"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Remove')), 1)
                    ]),
                    _: 1
                  }, 8, ["data-text"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_ac_button, {
              class: "actions_button -cancel",
              "data-text": _ctx.$t('CancelRemind'),
              onClick: _ctx.cancel,
              variant: "outlined"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('CancelRemind')), 1)
              ]),
              _: 1
            }, 8, ["data-text", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}